import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FileCode = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27.675 16C27.675 16 22.212 22.387 22.2 22.4C22.075 22.563 22 22.775 22 23C22 23.55 22.45 24 23 24C23.35 24 23.65 23.825 23.825 23.562L29.675 16.737C29.875 16.549 29.988 16.299 29.988 16.012C29.988 15.725 29.863 15.462 29.675 15.287L23.825 8.46205C23.65 8.20005 23.337 8.02405 23 8.02405C22.45 8.02405 22 8.47405 22 9.02405C22 9.24905 22.075 9.44905 22.2 9.62405C22.212 9.61205 27.675 15.999 27.675 15.999V16Z" />
		<path d="M4.325 16C4.325 16 9.788 9.613 9.8 9.6C9.925 9.438 10 9.225 10 9C10 8.45 9.55 8 9 8C8.65 8 8.35 8.175 8.175 8.438L2.325 15.263C2.125 15.451 2.012 15.701 2.012 15.988C2.012 16.275 2.137 16.538 2.325 16.713L8.175 23.538C8.35 23.8 8.663 23.976 9 23.976C9.55 23.976 10 23.526 10 22.976C10 22.751 9.925 22.551 9.8 22.376C9.788 22.388 4.325 16.001 4.325 16.001V16Z" />
		<path d="M20 5C20 4.45 19.55 4 19 4C18.538 4 18.15 4.313 18.038 4.725L12.038 26.737C12.013 26.824 12.001 26.9 12.001 26.987C12.001 27.537 12.451 27.987 13.001 27.987C13.464 27.987 13.851 27.674 13.964 27.249L19.964 5.237C19.989 5.174 20.002 5.087 20.002 5H20Z" />
	</svg>
);

export default FileCode;
